module.exports = __webpack_public_path__ + "static/media/grant.4f9ec2ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grant.jpg
// module id = 93
// module chunks = 0